import React from 'react'
import { PageTitle } from '_metronic/layout/core'

import { ClientSideTable } from 'Presentation/Components/Table'

import useViewModel from './ViewModel'
import formatNumberCommasNoDecimal from 'Utils/formatNumberCommasNoDecimal'

//////////
// View //
//////////

const MarketplaceCouponListView: React.FC = () => {
	const { totalData, data, TABLE_CONFIGS } = useViewModel()

	return (
		<ViewPageTitle>
			<div className="row gy-5">
				<div className="col-12">
					<div className="card border-1px border-kumopack-grey-200">
						<div className="card-header">
							<div className="card-title">
								All Coupons{' '}
								<div className="ms-2 fw-normal btn btn-sm border-radius-16px px-2 py-1 btn-kumopack-secondary-100 text-kumopack-secondary-700">
									{formatNumberCommasNoDecimal(totalData)} Coupons
								</div>
							</div>
						</div>

						<div className="card-body p-0">
							<ClientSideTable
								isGrey
								items_per_page={10}
								data={data}
								columns={TABLE_CONFIGS}
								customNoMatchText="No coupons found"
							/>
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
	return (
		<React.Fragment>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Marketplace',
						path: '/marketplace',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Coupons',
						path: '/marketplace/coupons',
						isActive: true,
						isSeparator: false,
					},
				]}>
				All Coupons
			</PageTitle>

			{children}
		</React.Fragment>
	)
}

export default MarketplaceCouponListView
